import React, { useContext } from 'react';
import styled from '@emotion/styled';
// import { colors } from '@atlaskit/theme';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { get } from 'lodash';
import QuoteItem from './DrapItem';
import { DrapItemContext } from './DrapItemContext';

const grid = 8;

export const getBackgroundColor = (): string => {
  return '';
  // if (isDraggingOver) {
  //   return colors.R50;
  // }
  // if (isDraggingFrom) {
  //   return colors.T50;
  // }
  // return colors.N30;
};

const Wrapper = styled.div`
  background-color: ${(props) => getBackgroundColor(props.isDraggingOver, props.isDraggingFrom)};
  display: flex;
  flex-direction: column;
  opacity: ${({ isDropDisabled }) => (isDropDisabled ? 0.5 : 'inherit')};
  transition: background-color 0.2s ease, opacity 0.1s ease;
  user-select: none;
  padding: ${grid}px;
  border: ${grid}px;
  padding-bottom: 0;
`;

const scrollContainerHeight: number = 250;

const DropZone = styled.div`
  /* stop the list collapsing when empty */
  /* min-height: ${scrollContainerHeight}px; */

  /*
    not relying on the items for a margin-bottom
    as it will collapse when the list is empty
  */
  /* padding-bottom: ${grid}px; */
`;

const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: ${scrollContainerHeight}px;
`;

const InnerQuoteList = React.memo(function InnerQuoteList() {
  const values = useContext(DrapItemContext);
  const { fields, quotes } = values;
  if (!fields || !fields?.length) {
    return null;
  }
  return fields?.map(({ name }, index) => {
    const quote = get(quotes, [name]);
    const id = get(quote, ['id']);
    return (
      <Draggable key={id} draggableId={id} index={index}>
        {(dragProvided, dragSnapshot) => (
          <QuoteItem
            name={name}
            quote={quote}
            provided={dragProvided}
            isDragging={dragSnapshot.isDragging}
            isGroupedOver={Boolean(dragSnapshot.combineTargetFor)}
          />
        )}
      </Draggable>
    );
  });
});

function InnerList(props: any) {
  const { dropProvided } = props;
  const title = props.title ? <div>{props.title}</div> : null;

  return (
    <div>
      {title}
      <DropZone ref={dropProvided.innerRef}>
        <InnerQuoteList />
        {dropProvided.placeholder}
      </DropZone>
    </div>
  );
}

export default function QuoteList(props: any) {
  const {
    ignoreContainerClipping,
    internalScroll,
    scrollContainerStyle,
    isDropDisabled,
    isCombineEnabled,
    listId = 'LIST',
    listType,
    style,
    // quotes,
    title,
    useClone,
  } = props;

  return (
    <Droppable
      droppableId={listId}
      type={listType}
      ignoreContainerClipping={ignoreContainerClipping}
      isDropDisabled={isDropDisabled}
      isCombineEnabled={isCombineEnabled}
      renderClone={
        useClone
          ? (provided, snapshot) => (
              <QuoteItem
                name={null}
                // quote={quotes[descriptor.source.index]}
                provided={provided}
                isDragging={snapshot.isDragging}
                isClone
              />
            )
          : null
      }
    >
      {(dropProvided, dropSnapshot) => (
        <Wrapper
          style={style}
          isDraggingOver={dropSnapshot.isDraggingOver}
          isDropDisabled={isDropDisabled}
          isDraggingFrom={Boolean(dropSnapshot.draggingFromThisWith)}
          {...dropProvided.droppableProps}
        >
          {internalScroll ? (
            <ScrollContainer style={scrollContainerStyle}>
              <InnerList title={title} dropProvided={dropProvided} />
            </ScrollContainer>
          ) : (
            <InnerList title={title} dropProvided={dropProvided} />
          )}
        </Wrapper>
      )}
    </Droppable>
  );
}
